import { AppDeviceLeaf } from 'types/common/leaf';

export const isWyze = (leaf: AppDeviceLeaf): boolean => leaf?.device?.partnerId === '663421';
